import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useAuth } from '../contexts/AuthContext';

const GOOGLE_CLIENT_ID = '803049080064-9oc5non7jo7beld6u7d1r0196je905fh.apps.googleusercontent.com';

interface GoogleJwt {
  email: string;
  name: string;
  picture: string;
}

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const { loginWithGoogle } = useAuth();

  const handleGoogleLogin = async (credentialResponse: any) => {
    setError(null);
    if (credentialResponse.credential) {
      try {
        const decoded: GoogleJwt = jwtDecode(credentialResponse.credential);
        if (decoded.email.endsWith('@architech.org')) {
          await loginWithGoogle(decoded);
          navigate('/');
        } else {
          setError('Only @architech.org Google accounts are allowed.');
        }
      } catch (e) {
        setError('Failed to decode Google token.');
      }
    } else {
      setError('Google login failed.');
    }
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div className="flex items-center justify-center min-h-screen">
        <div className="card max-w-md w-full mx-4">
          <h2 className="text-2xl font-bold text-white mb-6 text-center">Sign in to Token Launch League</h2>
          {error && (
            <div className="bg-red-900/20 border border-red-500/30 rounded-lg p-4 text-red-400 text-center mb-4">
              {error}
            </div>
          )}
          <div className="flex justify-center">
            <GoogleLogin
              onSuccess={handleGoogleLogin}
              onError={() => setError('Google Login Failed')}
              width="100%"
              theme="filled_blue"
              text="signin_with"
              shape="pill"
            />
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default Login; 